export var TranslationUtil = {
  getByKey: function (strKey) {
    var strValue = null;
    if (window.translations) {
      strValue = window.translations[strKey];
    }

    if (/*utils.isDev() && */!strValue) {
      strValue = strKey;
    }

    var showKey = false;

    if (window) {
      if (window.isClientDev) {
        strValue = strKey;
      }
      if (window.unescape) {
        strValue = window.unescape(strValue); // for chars that come from babel like &#39;
      }
    }

    return strValue;
  }
};



// WEBPACK FOOTER //
// ./utils/_translationUtils.js